<template>
    
    <address class="address">
        <strong>{{ data.raisonSociale1 }}</strong><br/>
        <span v-if="data.raisonSociale2">{{ data.raisonSociale2 }}<br/></span>
        {{ data.address1 }}<br/>
        <span v-if="data.address2">{{ data.address2 }}<br/></span>
        <span v-if="data.address3">{{ data.address3 }}<br/></span>
        {{ data.postalCode }} {{ data.city }} <span v-if="data.country">({{ data.country }})</span>
    </address>

</template>

<script>

export default {

    props: {
        data: Object
    }
}
</script>